import { Icon } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import React from 'react';
import styled from 'styled-components';

export interface INumericToggleIconState {
	id: string; // identifies component when more than one need to be synchronized
	open: boolean;
}

type NumericToggleProps = {
	color?: string;
	count?: number;
	iconOpen?: string;
	iconClosed?: string;
	id: string;
	open: boolean;
	onClick: (state: INumericToggleIconState) => void;
};

const NumericToggleWrapper = styled.div.attrs({ role: 'button' })<{ open: boolean; color: string; count?: number }>`
	cursor: pointer;
	display: inline-block;
	padding: 5px 8px;

	${(props) =>
		props.open
			? `
		background-color: ${globalVars.mainBlue};
		border-radius: 5px;
		color: ${globalVars.white};
		`
			: ''}

	:hover {
		background-color: ${globalVars.mainBlue};
		border-radius: 5px;
		color: ${globalVars.white};
	}

	span {
		font-size: 14px;
		${(props) => (!props.open ? `color: ${props.color};` : '')}
		${(props) => (props.count ? `margin-left: 2px;` : '')}
		.tws-i-icon {
			${(props) => (props.count ? 'font-size: 10px !important;' : `font-size: 14px !important;`)}
			position: relative;
		}
	}
`;
NumericToggleWrapper.displayName = 'NumericToggleWrapper';

const NumericToggleIcon = (props: NumericToggleProps) => {
	const { color, count, id, open, onClick } = props;
	const testId = `tws-numeric-toggle-${id}`;
	const iconOpen = props.iconOpen ? props.iconOpen : 'angle-up';
	const iconClosed = props.iconClosed ? props.iconClosed : 'angle-down';

	const handleClick = () => {
		onClick({
			id: id,
			open: !open,
		});
	};

	return (
		<NumericToggleWrapper
			id={id}
			data-testid={testId}
			className={testId}
			aria-expanded={open}
			aria-label={id}
			open={open}
			color={color || 'inherit'}
			count={count}
			onClick={handleClick}
		>
			<span title={open ? 'open' : 'closed'}>
				{count} <Icon name={open ? iconOpen : iconClosed} />
			</span>
		</NumericToggleWrapper>
	);
};

export default NumericToggleIcon;
